module.exports = __webpack_public_path__ + "img/idcardHandUrl_shili.144c1b31.png";